import { useEffect } from "react";
import { Link } from "react-router-dom";

const NavItem = (props) => {
    const toggleResponsiveMenu = () => {
        const sidebar = document.getElementById("sidebar");
        sidebar.classList.toggle("sidebar-responsive");
        const sidebarWrapper = document.getElementById("sm-wrapper");
        sidebarWrapper.classList.toggle("sm-wrapper-toggle");
    };

    const currentPath = window.location.pathname;

    // Extract the first segment of the current path
    const currentBasePath = currentPath.split("/")[1];

    // Determine if any child link exactly matches the current path or the base path
    const isActiveChild = props.item.children.some(
        (child) => 
            currentPath === child.link || 
            currentBasePath === child.link.split("/")[1]
    );
    
    const isActiveLink = currentPath === props.item.link || isActiveChild;

    useEffect(() => {
        if (isActiveChild) {
            // Expand the parent if a child is active
            const element = document.getElementById(`navItem-${props.item.id}`);
            if (element) {
                element.classList.add("show");
                element.scrollIntoView({
                    behavior: "smooth",
                    block: "center"
                });
            }
           
        }
    }, [isActiveChild, props.item.id]);

    return props.item.children.length > 0 ? (
        <div className={`side-item ${isActiveChild ? "active-parent" : ""}`}>
            <div id={`heading-${props.item.id}`}>
                <button
                    type="button"
                    data-toggle="collapse"
                    data-target={`#navItem-${props.item.id}`}
                    aria-expanded={isActiveChild ? "true" : "false"}
                    aria-controls="collapseOne"
                    className={isActiveChild ? "active" : ""}
                >
                    <div className={`link `}>
                        <i className={`${props.item.icon} change-color`}></i>
                        <span>{props.item.title}</span>
                    </div>
                    <i className="fas fa-chevron-down arrow-left"></i>
                    <div className="hover"></div>
                </button>
            </div>
            <div
                id={`navItem-${props.item.id}`}
                className={`collapse ${isActiveChild ? "show" : ""}`}
                aria-labelledby="headingOne"
                data-parent="#sidebar-menu"
            >
                <ul className="list-unstyled hide-on-collapse">
                    {props.item.children.map((child) => (
                        <li key={child.id} onClick={toggleResponsiveMenu}>
                            <Link to={child.link} className={currentPath === child.link ? "active-link" : ""}>
                                {child.title}
                            </Link>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    ) : (
        <Link
            to={props.item.link}
            className={`no-child ${isActiveLink ? "active-link" : ""}`}
            onClick={toggleResponsiveMenu}
        >
            <div className="link">
                <i className={`${props.item.icon} change-color`}></i>
                <span>{props.item.title}</span>
            </div>
            <i className="fas fa-chevron-left arrow-left"></i>
            <div className={`hover`}></div>
        </Link>
    );
};

export default NavItem;
